import { jsxs, jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel, useDateTimeFormat } from '@websolutespa/bom-mixer-hooks';
import { IconLlmTrash } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import style from './page-history.module.scss.js';

const PageHistory = _ref => {
  let {
    item
  } = _ref;
  const label = useLabel();
  const dateFormat = useDateTimeFormat({
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
  });
  const timeFormat = useDateTimeFormat({
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  });
  const {
    setHistory,
    removeHistory
  } = useLlm(state => state.actions);
  // console.log('item', item);
  return jsxs("div", {
    className: getClassNames(style.history),
    onClick: () => setHistory(item),
    children: [item.createdAt && jsxs("div", {
      className: style.head,
      children: [jsx("div", {
        className: style.date,
        children: dateFormat(item.createdAt)
      }), jsx("div", {
        className: style.time,
        children: timeFormat(item.createdAt)
      })]
    }), jsx("div", {
      className: style.user,
      children: item.user.text
    }), jsxs("div", {
      className: style.foot,
      children: [item.assistant ? jsx("div", {
        className: style.assistant,
        children: item.assistant.text
      }) : jsx("div", {
        className: style.assistant,
        children: label('llm.reasoning')
      }), item.messageId && jsx("button", {
        className: style.delete,
        onClick: event => {
          event.stopPropagation();
          removeHistory(item);
        },
        children: jsx(IconLlmTrash, {})
      })]
    })]
  });
};

export { PageHistory };
//# sourceMappingURL=page-history.js.map
